import { REQUIRED } from '@atlassian/jira-issue-create-common-types/src/common/constants/index.tsx';
import type { Option as FieldValue } from '@atlassian/jira-issue-field-parent-link/src/common/types.tsx';

export const validateParentLinkField = (
	data?: FieldValue,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	isRequired: boolean,
): string | undefined => {
	if (isRequired) {
		if (!data) {
			return REQUIRED;
		}
	}
	return undefined;
};
